import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import Raven from 'raven-js';
import { useEffect } from 'react';
import { getPaidUserManagementUrl } from 'self-service-api/core/utilities/links';
import * as tracker from 'ui-addon-upgrades/_core/common/eventTracking/tracker';
import { AssignSeatButtonPropsInterface } from 'ui-addon-upgrades/button/interfaces/requestAssignSeatButtonInterface';
import { getUpgradeDataTrackingProperties, mapPurchaseMotionApiName, trackPotentialBannerInteraction } from 'ui-addon-upgrades/ums/utils';
import { omit } from 'ui-addon-upgrades/utils';
import { getCorrectedUpgradeData } from '../_core/utils/getCorrectedUpgradeData';

const UIAssignSeatButton = props => {
  const {
    upgradeData,
    level,
    usageLimitBannerData,
    canViewNewSeats
  } = props;
  const upgradeDataWithApiName = Object.assign({}, upgradeData, {
    apiName: mapPurchaseMotionApiName(canViewNewSeats, upgradeData.upgradeProduct, 'UIAssignSeatButton', upgradeData.apiName)
  });
  const correctedUpgradeData = getCorrectedUpgradeData(upgradeDataWithApiName);
  const propsToPass = omit(props, 'isUpgradePoint', 'upgradeData', 'location', 'subscreen', 'level', 'usageLimitBannerData', 'canViewNewSeats');
  useEffect(() => {
    tracker.track('interaction', Object.assign({
      action: 'viewed assign seat',
      isPrimaryCta: level === 1,
      isSecondaryCta: level === 2
    }, usageLimitBannerData, {}, getUpgradeDataTrackingProperties(correctedUpgradeData, true)));
  }, [correctedUpgradeData, usageLimitBannerData, level]);

  const trackClick = () => {
    tracker.track('interaction', Object.assign({
      action: 'clicked upgrade point'
    }, usageLimitBannerData, {}, getUpgradeDataTrackingProperties(correctedUpgradeData, true)));
    tracker.track('interaction', Object.assign({
      action: 'clicked assign seat',
      isPrimaryCta: level === 1,
      isSecondaryCta: level === 2
    }, usageLimitBannerData, {}, getUpgradeDataTrackingProperties(correctedUpgradeData, true)));
    const {
      pointType,
      upgradeKey
    } = correctedUpgradeData;
    trackPotentialBannerInteraction(pointType, upgradeKey).catch(error => {
      Raven.captureException(new Error('Failed to submit interaction from UIAssignSeatButton'), {
        extra: {
          error
        }
      });
    });
  };

  return /*#__PURE__*/_jsx(UIButton, Object.assign({
    "data-reagan-primary-cta": true,
    "data-test-id": "assign-seat-button"
  }, propsToPass, {
    href: getPaidUserManagementUrl(canViewNewSeats),
    external: true,
    onClick: trackClick,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "upgrades.assignSeatButton"
    })
  }));
};

UIAssignSeatButton.propTypes = AssignSeatButtonPropsInterface;
export default UIAssignSeatButton;